import {
  FETCH_ORDERS,
  GET_ORDER,
  UPDATE_ORDER,
  GET_ORDER_SUCCESS,
  ORDER_UPDATED,
  ADD_MEMO,
  ADD_MEMO_SUCCESS,
  CLOSE_ORDER,
  CLOSE_ORDER_SUCCESS,
  REFUSE_CLOSE_ORDER,
  // CREATE_ORDER,
  ACCEPT_ORDER,
  ADD_ORDER,
  ORDERS_FETCHED,
  SHOW_ASSIGN_DIALOG,
  SHOW_PRICE_DIALOG,
  SHOW_SERVICE_TIME_DIALOG,
  SHOW_ASSIGN_WORKER_DIALOG,
  SHOW_ASSIGN_WORKER_SELECT_DIALOG,
  SET_WAIT_EXPRESS_STATUS,
  SET_COMPLETE_STATUS,
  SET_WORKER_COMPLETE,
  TOGGLE_ORDER_TAG,
  LOCK_ORDER_FEE,
  ORDER_PREVIEW,
  CONFIRM_LOCATION,
  SHOW_CREATE_ORDER_DIALOG,
  SHOW_APPEAL_DIALOG,
  SHOW_IMAGE_VIEW_DIALOG,
  SET_ACCEPT_STATUS,
  RE_SERVICE_DIALOG,
  SEND_WORKER_TO_USER,
  TENANT_CLOSE_ORDER,
  SHOW_EXPRESS_DIALOG,
  SHOW_EXPRESS_DETAIL_DIALOG,
  SHOW_ACCESSORY_DETAIL_DIALOG,
  SAVE_ORDER_ACCESSORY,
  SHOW_ORDER_EVALUATE_DIALOG,
  TASK_FETCHED,
  SHOW_ORDER_REMINDER
} from './actionTypes'

export const fetchOrders = params => ({ type: FETCH_ORDERS, payload: { params } })
export const ordersFetched = ({ data, total }) => ({ type: ORDERS_FETCHED, payload: { data, total } })
export const getOrder = id => ({ type: GET_ORDER, payload: { id } })
export const getOrderSuccess = data => ({ type: GET_ORDER_SUCCESS, payload: data })
export const addOrder = data => ({ type: ADD_ORDER, payload: data }) // 这个会将order加左侧列表内
export const updateOrder = id => ({ type: UPDATE_ORDER, payload: { id } })
export const orderUpdated = data => ({ type: ORDER_UPDATED, payload: data })
export const addMemo = (id, memo) => ({ type: ADD_MEMO, payload: { id, memo } })
export const addMemoSuccess = ({ id, memo }) => ({ type: ADD_MEMO_SUCCESS, payload: { id, memo } })
export const closeOrder = (id, params) => ({ type: CLOSE_ORDER, payload: { id, params } })
export const refuseCloseOrder = (id, params) => ({ type: REFUSE_CLOSE_ORDER, payload: { id, params } })
export const tenantCloseOrder = (id, params) => ({ type: TENANT_CLOSE_ORDER, payload: { id, params } })
export const closeOrderSuccess = ({ id, reason }) => ({ type: CLOSE_ORDER_SUCCESS, payload: { id, reason } })
// export const createOrder = data => ({ type: CREATE_ORDER, payload: data })
export const acceptOrder = (id, convId, onSuccess) => ({ type: ACCEPT_ORDER, payload: { id, convId, onSuccess } })
export const showAssignDialog = params => ({ type: SHOW_ASSIGN_DIALOG, payload: { params } })
export const showAppealDialog = params => ({ type: SHOW_APPEAL_DIALOG, payload: { params } })
export const showPriceDialog = params => ({ type: SHOW_PRICE_DIALOG, payload: { params } })
export const showServiceTimeDialog = params => ({ type: SHOW_SERVICE_TIME_DIALOG, payload: { params } })
export const showAssignWorkerDialog = params => ({ type: SHOW_ASSIGN_WORKER_DIALOG, payload: { params } })
export const showAssignWorkerSelectDialog = params => ({ type: SHOW_ASSIGN_WORKER_SELECT_DIALOG, payload: { params } })
// export const setWaitExpressStatus = (id, unset = false) => ({ type: SET_WAIT_EXPRESS_STATUS, payload: { id, unset }})
export const setCompleteStatus = id => ({ type: SET_COMPLETE_STATUS, payload: { id } })
export const setWorkerComplete = id => ({ type: SET_WORKER_COMPLETE, payload: { id } })
export const toggleOrderTag = (id, tag) => ({ type: TOGGLE_ORDER_TAG, payload: { id, tag } })
export const lockFee = params => ({ type: LOCK_ORDER_FEE, payload: params })
export const deduction = params => ({ type: ORDER_DEDUCTION, payload: params })
export const orderPreview = params => ({ type: ORDER_PREVIEW, payload: params })
export const confirmLocation = params => ({ type: CONFIRM_LOCATION, payload: params })
export const showCreateOrderDialog = params => ({ type: SHOW_CREATE_ORDER_DIALOG, payload: { params } })
export const showImageViewDialog = params => ({ type: SHOW_IMAGE_VIEW_DIALOG, payload: { params } })
export const setAcceptStatus = (id, status) => ({ type: SET_ACCEPT_STATUS, payload: { id, status } })
export const showReServiceDialog = (params) => ({
  type: RE_SERVICE_DIALOG
  , payload: { params }
})
export const sendWorkerToUser = params => ({ type: SEND_WORKER_TO_USER, payload: { params } })
export const showExpressDialog = params => ({ type: SHOW_EXPRESS_DIALOG, payload: { params } })
export const showExpressDetailDialog = params => ({ type: SHOW_EXPRESS_DETAIL_DIALOG, payload: { params } })
export const showAccessoryDetailDialog = params => ({ type: SHOW_ACCESSORY_DETAIL_DIALOG, payload: { params } })
export const saveOrderAccessory = data => ({ type: SAVE_ORDER_ACCESSORY, payload: { data } })
export const showOrderEvaluateDialog = params => ({ type: SHOW_ORDER_EVALUATE_DIALOG, payload: { params } })
export const taskFetched = ({ data, total }) => ({ type: TASK_FETCHED, payload: { data, total } })
export const showOredrReminder = (params) => ({ type: SHOW_ORDER_REMINDER, payload: { params } })
